module.exports = __webpack_public_path__ + "static/media/IconPause.41bd948e.svg";